import { entity } from "simpler-state"
import type { Granularity } from "./yoy_trend"

/**
 * What the Deduction Trends chart is currently showing. The chart owns its window (a multi-year
 * lookback, or a drilled-in range) and its granularity toggle independently of the global filter,
 * so it publishes them here for the dashboard export to match the screen.
 */
export interface ITrendViewState {
  granularity: Granularity
  /** Inclusive ISO bounds (yyyy-MM-dd) of the window the chart fetched. */
  startDate: string
  endDate: string
}

export const INITIAL_TREND_VIEW_STATE: ITrendViewState = {
  granularity: "year",
  startDate: "",
  endDate: "",
}

// Deliberately not persisted: it describes the chart on screen right now, not a user preference.
export const TrendViewState = entity(INITIAL_TREND_VIEW_STATE)
